import Box from '@mui/material/Box';
import { DateRangeChips, type DateRangeChipsProps } from './DateRangeChips.tsx';
import { DateRangeInputs } from './DateRangeInputs.tsx';

type DateRangePopoverContentProps = {
  minDate?: Date;
  maxDate?: Date;
  chipOptions?: DateRangeChipsProps['options'];
  dateFormat: string;
  endDateOptional?: boolean;
  startDateOptional?: boolean;
  startDateErrorMessage?: string;
  endDateErrorMessage?: string;
  disabled?: boolean;
  loading?: boolean;
};

export const DateRangePopoverContent = ({
  minDate,
  maxDate,
  chipOptions,
  dateFormat,
  endDateOptional = false,
  startDateOptional = false,
  disabled = false,
  loading = false,
}: DateRangePopoverContentProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, paddingY: 1 }}>
      {chipOptions && <DateRangeChips options={chipOptions} disabled={disabled} />}
      <DateRangeInputs
        minDate={minDate}
        maxDate={maxDate}
        dateFormat={dateFormat}
        endDateOptional={endDateOptional}
        startDateOptional={startDateOptional}
        disabled={disabled}
        loading={loading}
      />
    </Box>
  );
};
